import { render, staticRenderFns } from "./CaseSix.vue?vue&type=template&id=617b824d&scoped=true&"
import script from "./CaseSix.vue?vue&type=script&lang=js&"
export * from "./CaseSix.vue?vue&type=script&lang=js&"
import style0 from "./CaseSix.vue?vue&type=style&index=0&id=617b824d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b824d",
  null
  
)

export default component.exports